<template>
  <transition name="fade">
    <div class="container" v-if="isToastOpen">
      <div class="slds-notify_container">
        <div class="slds-notify slds-notify_toast" :class="'slds-theme_' + type" role="status">
          <span class="slds-assistive-text">{{type}}</span>
          <span class="slds-icon_container slds-m-right_small slds-no-flex slds-align-top" :class="'slds-icon-utility-' + type" :title="type">
            <svg class="slds-icon slds-icon_small" aria-hidden="true">
              <use v-if="type === 'success'" href="../../assets/symbols.svg#success"></use>
              <use v-if="type === 'warning'" href="../../assets/symbols.svg#warning"></use>
              <use v-if="type === 'error'" href="../../assets/symbols.svg#error"></use>
            </svg>
          </span>
          <div class="slds-notify__content">
            <h2 class="slds-text-heading_small">{{message}}</h2>
            <p v-if="details && messageType === 'HTML'" v-html="details"></p>
            <p v-else-if="details">{{details}}</p>
          </div>
          <div class="slds-notify__close">
            <button class="slds-button slds-button_icon slds-button_icon-inverse" title="Close" @click="hideToast">
              <svg class="slds-button__icon slds-button__icon_large" aria-hidden="true">
                <use href="../../assets/symbols.svg#close"></use>
              </svg>
              <span class="slds-assistive-text">{{$t('general.close')}}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import EventBus from './EventBus.js'
export default {
  data () {
    return {
      details: undefined,
      duration: undefined,
      iconUrl: undefined,
      isToastOpen: false,
      message: undefined,
      messageType: undefined,
      onCloseFn: undefined,
      type: undefined
    }
  },
  watch: {
    isToastOpen: function (newVal) {
      if (newVal && this.type === 'success') {
        setTimeout(() => this.hideToast(), 1800)
      }
    }
  },
  created () {

  },
  mounted () {
    EventBus.$on('show-toast', params => this.showToast(params.type, params.message, params.messageType, params.details, params.onCloseFn))
    EventBus.$on('hide-toast', params => this.hideToast)
    if (this.isToastOpen && this.type === 'success') {
      setTimeout(() => this.hideToast(), 1800)
    }
  },
  computed: {
  },
  methods: {
    showToast (type, message, messageType, details, onCloseFn) {
      this.type = type
      this.message = message
      this.messageType = messageType
      this.details = details
      this.onCloseFn = onCloseFn
      this.isToastOpen = true
    },
    hideToast: function () {
      this.isToastOpen = false
      if (this.onCloseFn) this.onCloseFn()
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  position: absolute;
}
.fade-enter {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s linear;
}

.fade-leave-to {
  opacity: 0;
}
</style>
